import React from 'react';

/**
 * Compact search field for filtering tables (inline, above tbody).
 */
export default function TableSearchInput({
  value,
  onChange,
  placeholder = 'Search…',
  style = {},
  inputStyle = {},
}) {
  return (
    <div style={{ position: 'relative', marginBottom: 10, maxWidth: 360, ...style }}>
      <svg
        style={{ position: 'absolute', left: 10, top: '50%', transform: 'translateY(-50%)', color: '#9CA3AF', pointerEvents: 'none' }}
        width="14"
        height="14"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        aria-hidden
      >
        <circle cx="11" cy="11" r="8" />
        <path d="M21 21l-4.35-4.35" />
      </svg>
      <input
        type="search"
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        autoComplete="off"
        style={{
          width: '100%',
          boxSizing: 'border-box',
          padding: '7px 10px 7px 32px',
          border: '1px solid #E5E7EB',
          borderRadius: 8,
          fontSize: 13,
          outline: 'none',
          fontFamily: 'inherit',
          background: '#F9FAFB',
          ...inputStyle,
        }}
      />
    </div>
  );
}
